import i18n from './../../shared/i18n';

import BaseModel from "../../core/components/input-widget/BaseModel";

export default class NoteListModel extends BaseModel {
  uuid = null;
  description = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    description: 'required',
  };

  attributeLabels = {
    description: i18n.t('Description'),
  };
}
